import React from 'react';
import classNames from 'classnames';
import { Classes, NumberInput } from '../index';

type RangeSliderProps = {
  min?: number;
  max?: number;
  value?: [number, number];
  initialValue?: [number, number];
  step?: number;
  onChange: (values: [number, number]) => void;
  className?: string;
  //zamezí změny minHodnoty
  disabledMin?: boolean;
  //zamezí změny maxHodnoty
  disabledMax?: boolean;
  //zamezí změny obou hodnot
  disabled?: boolean;
  hideNumberInput?: boolean;
  showInputBelow?: boolean;
};
export const RangeSliderInput: React.FC<RangeSliderProps> = ({
  min: initMin,
  max: initMax,
  value,
  initialValue: tempInitialValues,
  step = 1,
  disabledMin,
  disabledMax,
  disabled,
  className,
  hideNumberInput,
  showInputBelow,
  onChange,
}) => {
  const min = initMin || tempInitialValues?.[0] || 0;
  const max = initMax || tempInitialValues?.[1] || 100;
  const initialValue = tempInitialValues || [min, max];
  const [values, setValues] = React.useState(value ? value : initialValue);
  const [minTempValue, setMinTempValue] = React.useState(
    value?.[0] || initialValue[0]
  );
  const [maxTempValue, setMaxTempValue] = React.useState(
    value?.[1] || initialValue[1]
  );

  React.useEffect(() => {
    if (value) {
      setValues(value);
      setMinTempValue(value[0]);
      setMaxTempValue(value[1]);
    }
  }, [value]);
  let minValue = values[0];
  let maxValue = values[1];
  const handleMinInputChange = (newMin: number) => {
    if (disabled || disabledMin) return;
    if (newMin < min) newMin = min;
    if (newMin > maxValue) newMin = maxValue;
    if (!value) setValues([newMin, maxValue]);
    onChange([newMin, maxValue]);
    setMinTempValue(newMin);
    setMaxTempValue(maxValue);
  };
  const handleMaxInputChange = (newMax: number) => {
    if (disabled || disabledMax) return;
    if (newMax < minValue) newMax = minValue;
    if (newMax > max) newMax = max;
    if (!value) setValues([minValue, newMax]);
    onChange([minValue, newMax]);
    setMinTempValue(minValue);
    setMaxTempValue(newMax);
  };
  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (disabledMin || disabled) return;
    const newMinVal = Math.min(+e.target.value, maxValue);
    if (!value) setValues([newMinVal, maxValue]);
    onChange([newMinVal, maxValue]);
    setMinTempValue(newMinVal);
    setMaxTempValue(maxValue);
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (disabledMax || disabled) return;
    const newMaxVal = Math.max(+e.target.value, minValue);
    if (!value) setValues([minValue, newMaxVal]);
    onChange([minValue, newMaxVal]);
    setMinTempValue(minValue);
    setMaxTempValue(newMaxVal);
  };
  const mezera = 15;
  const minPos = ((minValue - min) / (max - min)) * 100;
  const maxPos = ((maxValue - min) / (max - min)) * 100;

  return (
    <div
      className={classNames(className, Classes.RANGE_SLIDER, {
        [Classes.SLIDER_SHOW_INPUT_BELOW]: showInputBelow,
      })}
    >
      {!hideNumberInput && !showInputBelow && (
        <NumberInput
          onSearch={() => handleMinInputChange(minTempValue)}
          className={Classes.SLIDER_NUMBER_INPUT_LEFT}
          disabled={disabled || disabledMin}
          value={minTempValue}
          onChange={(val) => setMinTempValue(val || minTempValue)}
          onBlur={(val) => handleMinInputChange(val || minTempValue)}
        />
      )}
      <div
        className={Classes.SLIDER_WRAPPER}
        style={{ marginRight: `${mezera}px` }}
      >
        <div className={Classes.SLIDER_INPUT_WRAPPER}>
          <input
            className={Classes.SLIDER_INPUT}
            type="range"
            value={minValue}
            min={min}
            max={max}
            step={step}
            onChange={handleMinChange}
          />
          <input
            style={{ left: `${mezera}px` }}
            className={Classes.SLIDER_INPUT}
            type="range"
            value={maxValue}
            min={min}
            max={max}
            step={step}
            onChange={handleMaxChange}
          />
        </div>

        <div className={Classes.SLIDER_CONTROL_WRAPPER}>
          <div
            className={classNames(Classes.SLIDER_CONTROL, {
              [Classes.SLIDER_DISABLED_CONTROL]: disabledMin || disabled,
            })}
            style={{ left: `${minPos}%` }}
          />
          <div
            style={{ width: `calc(100% + ${mezera / 2}px)` }}
            className={Classes.SLIDER_RAIL}
          >
            <div
              className={Classes.SLIDER_INNER_RAIL}
              style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }}
            />
          </div>
          <div
            className={classNames(Classes.SLIDER_CONTROL, {
              [Classes.SLIDER_DISABLED_CONTROL]: disabledMax || disabled,
            })}
            style={{ left: `calc(${maxPos}% + ${mezera / 2}px)` }}
          />
        </div>
      </div>
      <div className={Classes.SLIDER_SHOW_INPUT_BELOW_WRAPPER}>
        {!hideNumberInput && showInputBelow && (
          <NumberInput
            onSearch={() => handleMinInputChange(minTempValue)}
            className={Classes.SLIDER_NUMBER_INPUT_LEFT}
            disabled={disabled || disabledMin}
            value={minTempValue}
            onChange={(val) => setMinTempValue(val || minTempValue)}
            onBlur={(val) => handleMinInputChange(val || minTempValue)}
          />
        )}
        {!hideNumberInput && (
          <NumberInput
            onSearch={() => handleMaxInputChange(maxTempValue)}
            className={Classes.SLIDER_NUMBER_INPUT_RIGHT}
            disabled={disabled || disabledMax}
            value={maxTempValue}
            onChange={(val) => setMaxTempValue(val || maxTempValue)}
            onBlur={(val) => handleMaxInputChange(val || maxTempValue)}
          />
        )}
      </div>
    </div>
  );
};
